import { useState, useEffect, useRef } from "react";
import { ReactComponent as MyRelationship } from "../../Assets/images/myRelationship.svg";
import { ReactComponent as Support } from "../../Assets/images/support.svg";
import { ReactComponent as Subscription } from "../../Assets/images/subscription.svg";
import { ReactComponent as TermsOfUse } from "../../Assets/images/termsOfUse.svg";
import { ReactComponent as PrivacyPolicy } from "../../Assets/images/privacyPolicy.svg";
import { ReactComponent as SignOut } from "../../Assets/images/SignOut.svg";
import { ReactComponent as History } from "../../Assets/icon/ResumeCoaching.svg";
import { ReactComponent as PartnerChatIcon } from "../../Assets/images/partner_chat.svg";
import { ReactComponent as VoiceIcon } from "../../Assets/icon/voice.svg";
import { ReactComponent as FaithIcon } from "../../Assets/icon/prey.svg";
import { getRelationships } from "../../Services/Realtionship";
import { ReactComponent as Close } from "../../Assets/images/close.svg";
import { useHeader } from "../../Providers/HeaderContextProvider";
import { isOnboardingComplete } from "../../Utils/onboardingNavigation";
import { useFunctionalityAccess } from "../../Providers/FunctionalityAccessProvider";
import ChatModal from "../ChatModal/ChatModal";
import MobilePopUp from "../MobilePopUp/MobilePopUp";
import GroupMemberSelectionModal from "../../Pages/RelationShip/LiveSession/modals/session/GroupMemberSelectionModal";

function MenuComponent({
  close,
  closeMenu,
  setShowPopup,
  setShowLogoutPopup,
  hideRelationShipManager,
  isGroupModalOpen,
  setIsGroupModalOpen,
  coupleCoaching,
  setCoupleCoaching,
}) {
  const { profileContent } = useHeader();
  const { hasFeature, hasCoachingAccess, hasFaithAccess, hasUnlimitedCoaching, getCoachingMinutes, initialized: accessInitialized, FEATURE_CODES } = useFunctionalityAccess();
  // Helper to size icons consistently to 20x20
  const icon20 = (node) => {
    if (!node) return node;
    try {
      return { ...node, props: { ...node.props, width: 24, height: 24 } };
    } catch {
      return node;
    }
  };
  
  // Helper function for navigation without full page reload
  const navigateTo = (path) => {
    // Stop audio before navigation (keep WebSocket alive)
    if (window.stopCoachingAudio) {
      window.stopCoachingAudio();
    }
    // Use history.pushState to avoid full page reload but still trigger Router
    window.history.pushState({}, '', path);
    // Dispatch a popstate event to notify React Router
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
  
  const [pendingRequestCount, setPendingRequestCount] = useState(0);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const loadPendingRequests = async () => {
      try {
        const pendingRequests = await getRelationships();
        setPendingRequestCount(pendingRequests.length || 0);
      } catch (error) {
        console.error("Failed to fetch pending requests", error);
      }
    };

    loadPendingRequests();
  }, []);

   // Track viewport size for responsive modal rendering
  useEffect(() => {
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const aboutAris = () => {
    navigateTo("/about-aris");
  };
  const termOfUse = () => {
    navigateTo("/term-of-use");
  };
  const privacyPolicy = () => {
    navigateTo("/privacy-policy");
  };

  const onboarding = () => {
    navigateTo("/customer-support");
  };

  const gotoManageMembership = () => {
    navigateTo("/manageMembership");
  };

  const gotoCoachingHistory = () => {
    navigateTo("/coachingHistory");
  };

  const handleNavigateMyRelationship = () => {
    navigateTo("/manageRelationship");
  };

  const gotoElements = () => {
    navigateTo("/elements");
  };

  const gotoMyProfile = () => {
    navigateTo("/myprofile");
  };

  const gotoVoicePreference = () => {
    navigateTo("/voice-preference");
  };

  const gotoFaith = () => {
    navigateTo("/faith");
  };

  

  const handlePartnerDialogue = () => {
    setCoupleCoaching(true);
    setIsGroupModalOpen(true);
  };

  // Determine onboarding completion EARLY so it can be used below safely
  // Determine onboarding completion using Header context OR localStorage profile (for immediate reflect after redirect)
  const getCompletedStepsFromProfile = (p) => (
    p?.onboarding_step ?? p?.completed_steps ?? p?.completedSteps ?? []
  );
  const completedStepsHeader = getCompletedStepsFromProfile(profileContent || {});
  const [onboardingDoneLocal, setOnboardingDoneLocal] = useState(() => {
    try {
      const lp = JSON.parse(localStorage.getItem("profile") || "null");
      return isOnboardingComplete(getCompletedStepsFromProfile(lp || {}));
    } catch { return false; }
  });
  const onboardingDone = isOnboardingComplete(completedStepsHeader) || onboardingDoneLocal;

  // Keep local onboarding status in sync on route/navigation or storage updates
  useEffect(() => {
    const updateFromLocal = () => {
      try {
        const lp = JSON.parse(localStorage.getItem("profile") || "null");
        setOnboardingDoneLocal(isOnboardingComplete(getCompletedStepsFromProfile(lp || {})));
      } catch { /* no-op */ }
    };
    const onPop = () => updateFromLocal();
    const onStorage = (e) => { if (e.key === "profile") updateFromLocal(); };
    window.addEventListener('popstate', onPop);
    window.addEventListener('storage', onStorage);
    // Also run once when Header profile changes
    updateFromLocal();
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('storage', onStorage);
    };
  }, [profileContent]);

  // Build menu options; ensure My Profile is first
  // Each item can have a 'requiredFeature' property to control visibility based on functionality access
  const menuOptions = [
    {
      id: 0,
      name: "Profile",
      link: "/myprofile",
      icon: (
        profileContent?.profile_pic_url ? (
          <img src={profileContent.profile_pic_url} alt="Profile" width={24} height={24} style={{ borderRadius: "50%" }} />
        ) : (
          <div className="header-profile-circle-image" style={{ width: 24, height: 24, fontSize: 12 }}>
            {`${profileContent?.first_name?.[0]?.toUpperCase() || ""}${profileContent?.last_name?.[0]?.toUpperCase() || ""}`}
          </div>
        )
      ),
      function: gotoMyProfile,
    },
    {
      id: 8,
      name: "Your Elements",
      link: "/elements",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.7887 7.21897C20.5873 6.92925 20.2853 6.68781 19.9833 6.49466L11.9296 0.603593C11.6276 0.410443 11.3255 0.169006 10.9732 0.0724311C10.6712 -0.0241437 10.3692 -0.0241437 10.1175 0.0724311C9.76513 0.169006 9.46312 0.410443 9.1611 0.603593L1.05705 6.49466C0.755036 6.68781 0.453022 6.92925 0.251679 7.21897C0.100671 7.46041 0 7.75013 0 8.03986C0 8.37787 0.100671 8.71588 0.201343 9.10218L3.27182 18.5665C3.37249 18.9045 3.47317 19.2425 3.72484 19.5323C3.92619 19.7737 4.12753 19.9186 4.42954 20.0151C4.68122 20.1117 4.98324 20.1117 5.23492 20.16H15.7551C16.0068 20.16 16.3088 20.16 16.5605 20.0151C16.8121 19.9186 17.0638 19.7254 17.2652 19.5323C17.5168 19.2425 17.6175 18.9045 17.7182 18.5665L20.7887 9.10218C20.8893 8.76417 21.0403 8.42616 20.99 8.03986C20.99 7.75013 20.8893 7.46041 20.7383 7.21897H20.7887ZM18.7752 7.36383L13.9933 9.00561L11.8289 2.34194L18.7752 7.36383ZM10.0168 1.76249L12.7349 10.1645L14.245 15.959L2.06377 7.5087L10.0168 1.76249ZM15.5034 18.6631H5.53693C5.33559 18.6631 5.18458 18.6631 5.08391 18.6631C5.08391 18.6631 5.03357 18.6631 4.98324 18.6631C4.98324 18.6631 4.9329 18.6631 4.88257 18.5665C4.88257 18.5665 4.88257 18.5665 4.88257 18.4699C4.88257 18.3734 4.78189 18.2768 4.73156 18.0354L1.81209 9.10218L15.0504 18.2285L15.7048 18.6631C15.6544 18.6631 15.6041 18.6631 15.5034 18.6631ZM16.3591 17.9871L16.2081 17.5042L14.396 10.4059L19.3793 8.66759L16.3591 17.9871Z" fill="white"/></svg>
      ),
      function: gotoElements,
      requiredFeature: 'ELEMENTS',
    },
    {
      id: 7,
      name: "Session History",
      link: "/",
      icon: { ...icon20(<History />) },
      function: gotoCoachingHistory,
      requiredFeature: 'COACHING',
    },
    {
      id: 6,
      name: "Manage Membership",
      link: "/",
      icon: { ...icon20(<Subscription />) },
      function: gotoManageMembership,
      requiredFeature: 'SUBSCRIPTION',
    },
    {
      id: 9,
      name: "Aris Dialogues for Two",
      link: "/dialogues",
      icon: { ...icon20(<PartnerChatIcon />) },
      function: handlePartnerDialogue,
      requiredFeature: 'DIALOGS_FOR_TWO',
    },
    {
      id: 11,
      name: "Voice Preference",
      link: "/voice-preference",
      icon: { ...icon20(<VoiceIcon />) },
      function: gotoVoicePreference,
    },
    {
      id: 12,
      name: "Faith & Spirituality",
      link: "/faith",
      icon: { ...icon20(<FaithIcon />) },
      function: gotoFaith,
    },
    {
      id: 5,
      name: "Support",
      link: "/customer-support",
      icon: { ...icon20(<Support />) },
      function: onboarding,
    },
    {
      id: 10,
      name: "Admin",
      link: "/admin",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="white"/>
          <path d="M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.97 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H10C9.75 2 9.54 2.18 9.51 2.42L9.13 5.07C8.52 5.32 7.96 5.66 7.44 6.05L4.95 5.05C4.73 4.96 4.46 5.05 4.34 5.27L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11.02C4.53 11.34 4.5 11.67 4.5 12C4.5 12.33 4.53 12.66 4.57 12.98L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.95C7.96 18.35 8.52 18.68 9.13 18.93L9.51 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.27 19.04 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16Z" fill="white"/>
        </svg>
      ),
      function: () => navigateTo("/admin"),
      requiredFeature: 'ADMIN',
    },
  ];

  if (!hideRelationShipManager) {
    menuOptions.splice(1, 0, {
      id: 2,
      name: "My Connections",
      link: "/manageRelationship",
      icon: { ...icon20(<MyRelationship />) },
      function: handleNavigateMyRelationship,
      requiredFeature: 'RELATIONSHIPS',
    });
  }

  // Filter menu options based on functionality access
  const filterByFeatureAccess = (options) => {
    if (!accessInitialized) return options; // Show all while loading
    return options.filter((item) => {
      if (!item.requiredFeature) return true; // No feature requirement
      // Use hasFeature for all feature checks
      return hasFeature(item.requiredFeature);
    });
  };

  // Local handlers that respect onboarding completion for routing
  const goToTerms = () => navigateTo("/term-of-use");
  const goToPrivacy = () => navigateTo("/privacy-policy");

  // Base fixed items
  const fixedMenuOptions = [
    {
      id: 1,
      name: "Terms of Service",
      link: "/term-of-use",
      icon: { ...icon20(<TermsOfUse />) },
      function: goToTerms,
    },
    {
      id: 2,
      name: "Privacy Policy",
      link: "/privacy-policy",
      icon: { ...icon20(<PrivacyPolicy />) },
      function: goToPrivacy,
    },
    {
      id: 3,
      name: "Logout",
      link: "/logout",
      icon: { ...icon20(<SignOut />) },
      function: () => navigateTo("/logout"),
    },
  ];

  // If onboarding is incomplete, only show the whitelisted fixed items and hide the rest
  // Also filter by feature access for items that require specific features
  const visibleMenuOptions = onboardingDone ? filterByFeatureAccess(menuOptions) : [];
  const visibleFixedOptions = onboardingDone
    ? fixedMenuOptions
    : fixedMenuOptions.filter((item) =>
        ["Member Agreement", "Privacy Policy", "Logout"].includes(item.name)
      );

  return (
    <div className="menu-hero-container">
      <div className="menu-cust-container">
        <div className="header-option-close-icon" onClick={closeMenu}>
          <Close />
        </div>
        {visibleMenuOptions.map((item) => (
          <div
            className="menu-txt-container"
            key={item.id}
            onClick={item.function}
          >
            {item.icon}
            <span>{item.name}</span>
            {item.id === 2 && pendingRequestCount > 0 && (
              <span className="pending-relationship-badge">
                {pendingRequestCount}
              </span>
            )}
          </div>
        ))}
      </div>

      <div className="menu-cust-container fixed-cnt">
        {visibleFixedOptions.map((item) => (
          <div
            className="menu-txt-container"
            key={item.id}
            onClick={item.function}
          >
            {item.icon} {item.name}
          </div>
        ))}
      </div>

      {/* Partner Dialogue Modal */}
      {isGroupModalOpen && (
        <>
          {screenWidth > 480 ? (
            <ChatModal
              isOpen={isGroupModalOpen}
              onClose={() => setIsGroupModalOpen(false)}
              children={
                <GroupMemberSelectionModal
                  onClose={() => setIsGroupModalOpen(false)}
                  hideCloseIcon={false}
                  coupleCoaching={coupleCoaching}
                />
              }
              height={'fit-content'}
              width={'476px'}
            />
          ) : (
            <MobilePopUp
              isPopupVisible={isGroupModalOpen}
              onClose={() => setIsGroupModalOpen(false)}
              children={
                <GroupMemberSelectionModal
                  onClose={() => setIsGroupModalOpen(false)}
                  hideCloseIcon={true}
                  coupleCoaching={coupleCoaching}
                />
              }
              hideClose={false}
            />
          )}
        </>
      )}

    </div>
  );
}

export default MenuComponent;
